<ion-app [ngClass]="{'desktop' : isDesktop, 'edge-styles': isEdge}">
  <router-outlet main></router-outlet>
</ion-app>
<pptl-loader></pptl-loader>
